import * as React from "react"
import "./button.scss"

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  "data-style"?: "ghost" | "default"
  "data-active"?: boolean
  "data-disabled"?: boolean
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, children, onMouseDown, ...props }, ref) => {
    // Предотвращаем потерю фокуса редактора при клике на кнопку
    const handleMouseDown = (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault()
      onMouseDown?.(e)
    }

    return (
      <button
        ref={ref}
        className={`tiptap-button ${className || ""}`}
        onMouseDown={handleMouseDown}
        {...props}
      >
        {children}
      </button>
    )
  }
)

Button.displayName = "Button"
